var map = {
	"./商業英文.png": "2e65",
	"./多益專區.png": "e8934",
	"./學習資源.png": "8cba",
	"./寫作專區.png": "050c",
	"./新聞英語.png": "d521",
	"./生活英文.png": "a658",
	"./雅思專區.png": "515e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5be1";